import { render, staticRenderFns } from "./AgentDashboard.vue?vue&type=template&id=aa35cdfc&scoped=true"
import script from "./AgentDashboard.vue?vue&type=script&lang=js"
export * from "./AgentDashboard.vue?vue&type=script&lang=js"
import style0 from "./AgentDashboard.vue?vue&type=style&index=0&id=aa35cdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa35cdfc",
  null
  
)

export default component.exports